import React, { useEffect, useState, useRef } from 'react';
import { Form, Container, Alert } from 'react-bootstrap';
import api from '../../services/client';
import { setValue } from '../../helpers/localStorageHelper';
import styled from 'styled-components';
import { useAuth } from '../../auth/AuthContext';
import routes from '../routes';
import { Redirect, NavLink as Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import BannerImage from '../../assets/JobBoard_Banner.png';
import TitleImage from '../../assets/Login_Title.png';


const Banner = styled.div`
    background-image: url(${BannerImage});
    min-height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 450px) {
        min-height: 225px;
    }
`;
const Title = styled.div`
    background-image: url(${TitleImage});
    min-height: 139px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 65%;    
    margin: auto;
    @media screen and (max-width: 450px) {
        min-height: 60px;
    }
`;

const LoginHeader = styled.div`
    padding: 4% 6%;
`;

const ForgetPassword = styled(Link)`
    display: inline-block;
    color: red;
    float: right;
    text-align: right;
`


function Login() {
    const history = useHistory();
    const { login, currentUser, tokenExp, updateUser } = useAuth();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const loginForm = useRef();

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        var formData = new FormData(loginForm.current),
            formDataObj = Object.fromEntries(formData.entries());
        if (validateEmail(formDataObj.Username)) {
            formDataObj['Email'] = formDataObj.Username;
            formDataObj.Username = undefined;
        }
        const res = await login(formDataObj);
        if (res.status != 200) {
            setError(true);
            setErrorMessage(res.message)
        } else {
            updateUser(res?.payload);
            history.push(res?.payload.result.UserRole == "Admin" ? routes.ADMINCOMPANIES : routes.JOBS);
        }
    }


    return !(currentUser && tokenExp > new Date()) ? (
        <>
            <Banner />
            <Title />
            <div className='title'>Thank you for participating in our veteran job fair. Please Login to your account.</div>
            <div className='signup-container'>
                <Container>
                    <Form ref={loginForm}>

                        {error && <Alert variant='danger' style={{ width: '80%', marginLeft: '10%', marginTop: '2%' }}>{errorMessage}</Alert>}
                        <LoginHeader>
                            <p className="text-center"> Login To Access Your Acount </p>
                            <Form.Group className="mb-2" controlId="formBasicUsernameEmail">
                                <Form.Control type="text" name="Username" placeholder="Username or Email Address" />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Control type="password" name="Password" placeholder="Your Password" />
                            </Form.Group>
                            <Form.Group className="mb-2" controlId="formBasicCheckbox">
                                <table style={{width: '100%'}}>
                                    <tr>
                                        <td> <Form.Check type="checkbox" label="Remember me" /></td>
                                        <td>   <ForgetPassword  to ={routes.FORGOTPASSWORD}>Forget Password?</ForgetPassword></td>
                                    </tr>
                                </table>
                            </Form.Group>

                        </LoginHeader>

                    </Form>
                    <button className='btnClass' onClick={handleOnSubmit}>Login</button>
                </Container>
            </div>
        </>

    ) : (<Redirect to={routes.JOBS} />)
}

export default Login

